import React, { Component } from 'react';
import { Button, Sheet, HeadingText, BodyText } from '@paypalcorp/pp-react';
import TemplateData, { localsMessages } from '../../utility/getTemplateData';
import PropTypes from 'prop-types';
import { appendCdnHostName } from '../../utility/geoUtils';
import { sanitizeOrgName } from '../../utility/domUtils';
import BackButton from '../../components/BackButton';
import { isInContext } from '../../utility/inContextDonation';
import { Row, Col } from '@paypalcorp/pp-react';

let texts = localsMessages('common/recurring-checkbox');

const orgname = TemplateData.donationName ? TemplateData.donationName : '';

export class RecurringOverlay extends Component {
  handleClose = () => {
    this.props.closeRecurringOverlay();
  };

  noThanks_closeModal = (event) => {
    this.props.onMakeOneTimeDonation();
  };

  onContinue = (event) => {
    this.props.onContinue();
  };

  render() {
    let {
      rp: {
        signupHeader,
        dialogp1,
        dialogp2,
        dialogp3,
        dialogp2Week,
        dialogp2Year,
        continueBtn,
        noThanksBtn,
      } = {},
    } = texts || {};

    dialogp1 =
      dialogp1 && dialogp1.replace('{orgName}', sanitizeOrgName(orgname));
    let secondDialog = dialogp2;

    switch (this.props.selectedRecurringFrequency) {
      case 'WEEK':
        secondDialog = dialogp2Week;
        break;
      case 'YEAR':
        secondDialog = dialogp2Year;
        break;
      default:
        secondDialog = dialogp2;
        break;
    }

    secondDialog =
      secondDialog &&
      secondDialog.replace('{orgName}', sanitizeOrgName(orgname));

    return (
      <Sheet
        hideTitle
        center
        action={
          isInContext() ? <BackButton onClick={this.handleClose} /> : null
        }
        noCloseButton={isInContext()}
        isOpen={this.props.isOpen}
        onClose={this.handleClose}
        closeOnBackgroundClick={false}
        className="recurring-signup-overpanel"
        containerClassName={`${
          isInContext() ? 'incontext-guest-recurring' : ''
        }`}
      >
        <div className="modal-body">
          <div>
            <Row>
              <Col>
                <div className="icon-container">
                  <img
                    src={appendCdnHostName(
                      '/paypal-ui/illustrations/focused/svg/calendar-heart.svg'
                    )}
                    alt="icRecurring"
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <HeadingText size="sm">{signupHeader}</HeadingText>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="content">
                  <div className="content-row">
                    <div className="icon-column">&#9679;</div>
                    <BodyText className="text-column">{dialogp1}</BodyText>
                  </div>
                  <div className="content-row">
                    <div className="icon-column">&#9679;</div>
                    <BodyText className="text-column">{secondDialog}</BodyText>
                  </div>
                  <div className="content-row">
                    <div className="icon-column">&#9679;</div>
                    <BodyText className="text-column">{dialogp3}</BodyText>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="actions">
              <Row className="mb-16">
                <Col>
                  <Button className="btn-wide" onClick={this.props.onContinue}>
                    {continueBtn}
                  </Button>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Button
                    secondary
                    className="btn-wide"
                    id="noThanks"
                    onClick={this.noThanks_closeModal}
                  >
                    {noThanksBtn}
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </Sheet>
    );
  }
}

RecurringOverlay.propTypes = {
  closeRecurringOverlay: PropTypes.func,
  onMakeOneTimeDonation: PropTypes.func,
  onContinue: PropTypes.func,
  isOpen: PropTypes.bool,
  selectedRecurringFrequency: PropTypes.string,
};

export default RecurringOverlay;
